import { z } from 'zod';
import { PostPositionOrderResponseSchema } from '../order/post-position-order.ts';
import { ORDER_SOURCE_SCHEMA } from '../order/order-source.ts';

export const CreatePositionOrderUrlSchema = z.strictObject({
    positionId: z.string().uuid(),
});

export const CreatePositionOrderResponseSchema = PostPositionOrderResponseSchema;

export type CreatePositionOrderUrl = z.infer<typeof CreatePositionOrderUrlSchema>;

export const CreatePositionOrderRequestSchema = z.object({
    source: ORDER_SOURCE_SCHEMA.default(ORDER_SOURCE_SCHEMA.Values.GENERIC_POSITION),
});
